<template>
  <div>
    <p class="force-wrap mb-0" :class="{ 'pre-line': !readMore || !truncate }">{{ truncatedText }}<span v-if="readMore && text.length > length"><a href="#" class="text-primary ml-1" @click.prevent="truncate = !truncate">{{ truncate ? '続きを読む' : '切り詰める' }}</a></span></p>
    <div class="text-center fs-14" v-if="!readMore && text.length > length">
      <b-button variant="link" @click="truncate = !truncate"><i :class="[ truncate ? 'fa-chevron-down' : 'fa-chevron-up', 'fa' ]"></i></b-button>
    </div>
  </div>
</template>

<script>
import Form from 'vform'

export default {
  name: 'vP',
  
  data: () => ({
    truncate: true
  }),

  props: {
    text: {
      type: String,
      default: ''
    },
    length: {
      default: 60,
    },
    readMore: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    truncatedText: function () {
      if ( this.text != null && this.text.length > this.length && this.truncate) {
				return this.text.substring(0, parseInt(this.length)) + '...'
			}
			return this.text
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Truncate.vue